/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

const raw = PropTypes.shape({
  fields: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  html: PropTypes.string,
})

const rawList = PropTypes.shape({
  edges: PropTypes.arrayOf({
    node: raw.isRequired,
  }).isRequired,
})

const single = PropTypes.shape({
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

const list = PropTypes.arrayOf(single)

const documentShape = { raw, rawList, single, list }

export default documentShape

export const documentFragment = graphql`
  fragment Document on MarkdownRemark {
    fields {
      title
    }
    html
  }
`
